function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/* eslint-disable react-native/no-inline-styles */
import React, { useState } from 'react';
import { StyleSheet, Text, TouchableOpacity, TouchableWithoutFeedback, View } from 'react-native';
import cloneWithProps from '../../../shared/utils/dom/cloneWithProps';
import { IS_MOBILE } from '../../../shared/utils/platform/getPlatform';
import { WIDTH } from '../../../shared/utils/theme/getSize';
import { colors, icons } from '../constants';
import Button from './Button';
import { ToggleButtons } from './ToggleButtons';
import { Typography } from './Typography';
const {
  GearIcon,
  DoubleArrowUpIcon,
  CloseIcon,
  BackIcon
} = icons;
const TopBar = _ref => {
  let {
    title,
    isVisibleBackButton,
    isVisibleRouteButton,
    isVisibleCancelButton,
    externalStyles,
    animationsEnabled,
    leftIcon,
    rightIcon,
    rightActiveIcon,
    toggleAnimation,
    backButton,
    undoButtonAction,
    restartButtonAction
  } = _ref;
  const {
    buttons,
    containerStyle,
    additionalButtonsContainerStyles,
    animationsTogglerContainer,
    toggleStyle,
    leftIconStyle,
    rightActiveIconStyle,
    rightIconStyle,
    leftButtonStyle,
    rightButtonStyle,
    rightActiveButtonStyle
  } = externalStyles || {};
  const [showOptions, setShowOptions] = useState(false);
  const handleDropButtons = () => {
    setShowOptions(!showOptions);
  };
  return /*#__PURE__*/React.createElement(TouchableWithoutFeedback, {
    onPress: () => setShowOptions(false)
  }, /*#__PURE__*/React.createElement(View, {
    style: [styles.container, containerStyle]
  }, isVisibleBackButton && /*#__PURE__*/React.createElement(TouchableOpacity, {
    onPress: event => {
      event.stopPropagation();
      backButton && backButton();
    },
    style: [styles.headerButton, leftButtonStyle]
  }, (leftIcon ? cloneWithProps(leftIcon, leftIconStyle) : undefined) || /*#__PURE__*/React.createElement(BackIcon, {
    width: 26,
    height: 26,
    color: colors.neutral900
  })), !!title && /*#__PURE__*/React.createElement(Typography.ActionBig, null, title), (undoButtonAction || restartButtonAction) && /*#__PURE__*/React.createElement(View, {
    style: {
      flex: 1,
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-end'
    }
  }, undoButtonAction && /*#__PURE__*/React.createElement(Button, _extends({
    buttonContainerStyle: [styles.headerButton, rightButtonStyle],
    label: "Undo",
    handlePress: () => {
      undoButtonAction();
    }
  }, buttons?.undo || {})), restartButtonAction && /*#__PURE__*/React.createElement(Button, _extends({
    label: "Restart",
    buttonContainerStyle: [styles.headerButton, rightButtonStyle],
    handlePress: () => {
      restartButtonAction();
    }
  }, buttons?.restart || {}))), isVisibleRouteButton && /*#__PURE__*/React.createElement(TouchableOpacity, {
    style: [styles.headerButton, rightButtonStyle, showOptions ? rightActiveButtonStyle : {}],
    onPress: _event => {
      // event.stopPropagation();
      handleDropButtons();
    }
  }, showOptions ? (rightActiveIcon ? cloneWithProps(rightActiveIcon, rightActiveIconStyle) : undefined) || /*#__PURE__*/React.createElement(DoubleArrowUpIcon, {
    width: 28,
    height: 28,
    color: colors.neutral900
  }) : (rightIcon ? cloneWithProps(rightIcon, rightIconStyle) : undefined) || /*#__PURE__*/React.createElement(GearIcon, {
    width: 28,
    height: 28,
    color: colors.neutral900
  })), isVisibleCancelButton && /*#__PURE__*/React.createElement(TouchableOpacity, {
    onPress: event => {
      event.stopPropagation();
      backButton && backButton();
    },
    style: [styles.headerButton, styles.selfEnd]
  }, /*#__PURE__*/React.createElement(CloseIcon, {
    width: 28,
    height: 28,
    color: colors.neutral900
  })), showOptions && /*#__PURE__*/React.createElement(View, {
    style: [styles.additionalButtonsContainer, additionalButtonsContainerStyles]
  }, /*#__PURE__*/React.createElement(View, {
    style: [styles.animationsTogglerContainer, animationsTogglerContainer]
  }, /*#__PURE__*/React.createElement(ToggleButtons, {
    active: animationsEnabled,
    setToggleState: toggleAnimation,
    type: "small",
    externalToggleStyles: toggleStyle
  }), /*#__PURE__*/React.createElement(Text, {
    style: styles.animationsTogglerText
  }, "Animations")))));
};
const styles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'row',
    minHeight: 50,
    height: 48,
    alignSelf: 'stretch',
    alignItems: 'center',
    justifyContent: 'space-between',
    zIndex: 2
  },
  headerButton: {
    width: 48,
    height: 48,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginHorizontal: 8
  },
  selfEnd: {
    alignSelf: 'flex-end'
  },
  additionalButtonsContainer: {
    display: 'flex',
    flexDirection: 'column',
    position: 'absolute',
    top: 50,
    right: 16,
    backgroundColor: 'white',
    borderWidth: 2,
    borderColor: '#ccc',
    borderRadius: 8,
    padding: 16,
    width: IS_MOBILE ? WIDTH - 32 : 200,
    alignItems: 'flex-start'
  },
  separator: {
    height: 1,
    backgroundColor: '#ccc',
    alignSelf: 'stretch',
    display: 'flex',
    marginVertical: 10
  },
  animationsTogglerContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 4,
    paddingLeft: 5
  },
  animationsTogglerText: {
    fontWeight: '600',
    marginLeft: 8,
    fontSize: 16
  }
});
export default TopBar;
//# sourceMappingURL=TopBar.js.map